import { ApiError } from "./api";

const getMissingPermissions = (data: unknown): string[] => {
  if (typeof data !== "object" || data === null || !("details" in data)) {
    return [];
  }
  const { details } = data;
  if (typeof details !== "object" || details === null || !("missingPermissions" in details)) {
    return [];
  }
  const { missingPermissions } = details;
  return Array.isArray(missingPermissions)
    ? missingPermissions.filter((permission): permission is string => typeof permission === "string")
    : [];
};

export const formatChangeRequestApproveError = (
  error: Error,
  translate: (key: string, options?: Record<string, string>) => string,
): string => {
  if (error instanceof ApiError) {
    if (error.message === "change_request_missing_permissions") {
      const permissions = getMissingPermissions(error.data)
        .map((permission) => translate(`storeChatSessions.changeRequest.permissions.${permission}`))
        .join(", ");
      return translate("storeChatSessions.changeRequest.missingPermissions", { permissions });
    }
    const translationKey = `storeChatSessions.changeRequest.errors.${error.message}`;
    const translated = translate(translationKey);
    if (translated !== translationKey) {
      return translated;
    }
  }

  return error.message;
};
